import Button from "./Button";
import { Pencil } from "lucide-react";

function EditButton({ children, ...props }) {
  return (
    <Button {...props} data-testid="Edit Button" px="px-3">
      <Pencil className="w-4 h-4" />
      {children}
    </Button>
  );
}

export default EditButton;
